import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../Services/auth.service';
import Swal from 'sweetalert2';
import { SubscriptionService } from '../../Services/subscription.service';
import { ActivatedRoute } from '@angular/router';
import { MemberService } from '../../Services/member.service';
import { isTemplateExpression } from 'typescript';

@Component({
  selector: 'app-subscription-list-member-edit',
  template: require('./subscription-list-member-edit.component.html'),
  styles: [require('./subscription-list-member-edit.component.css')]
})

export class SubscriptionEditMemberComponent implements OnInit {
  loading: boolean = false;
  subscriptionId = 0;
  members: any[] = [];
  subscription:any = {};

  nameSearchString: string = '';
  searched_members: any[] = [];
  firstnames: any[] = [];
  lastnames: any[] = [];
  selectedMembersCount: number = 0;
  selectedExtrasCount:number = 0;
  showOnlySelected: boolean = false;

  selected_members:any[] = [];

  current_member: any ={
    firstName: "",
    lastName: ""
  };

  amountOFColspan:number = 11;

  constructor(  
          private route: ActivatedRoute,
          private auth: AuthService, 
          private subscriptionService: SubscriptionService,
          private memberService: MemberService ) {
      
      route.params.subscribe(p => {
        if (p['id'])
          this.subscriptionId = +p['id'];
        else
          this.subscriptionId = 0;
      });
  }

  ngOnInit() {
    this.loadAll();
  }

  loadAll(){
    this.selected_members.length = 0;
    this.getSubscriptionInformation();
    this.getAllMembersForSubscription()
    this.loadAllMembers();
    this.showOnlySelected = false;
  }

  calculateColspan(){
    var begin = 10;

    if (this.subscription.openForNonMembers){     
      begin += 2
    }
    if (this.subscription.openForNonRaceBikes){
      begin += 2
    }
    if (this.subscription.extraQuestion){
      begin += 1
    }
    this.amountOFColspan = begin;
  }

  getSubscriptionInformation(){
    this.subscriptionService.getSubscriptionById(this.subscriptionId).subscribe( res =>{
      this.subscription = res;
      // console.log(this.subscription)
      this.calculateColspan()
    })
  }

  getAllMembersForSubscription(){
    this.subscriptionService.GetCurrentMembersForSubscription(this.subscriptionId).subscribe(x => {
      // console.log(x);
      
      x.forEach((e:any) => {
        var i:any = { 
            memberId: e.memberId, 
            hasPayedDeposit: e.hasPayedDeposit, 
            hasPayedFull: e.hasPayedFull,
            subscribed: true, 
            extras: e.extras, 
            extraNames: e.extraNames, 
            remarks: e.remarks, 
            singleRoom:e.singleRoom,
            amountOfNonStdBikes:e.amountOfNonStdBikes,
            kindOfBikes: e.kindOfBikes,
            exemptFromPaying: e.exemptFromPaying,
            personalTransport: e.personalTransport,
            extraQuestionResponse: e.extraQuestion

           }
        this.selected_members.push(i);
      });
      var x:any =  this.doCountOfSubscribedMembers()
      this.selectedExtrasCount = x.extrasCount;
      this.selectedMembersCount = x.membersCount;
      
    })
  }

  loadAllMembers(){
    this.loading = true;
    this.memberService.getSimpleMembers().subscribe (res => {
      this.members = res;
      var x:any =  this.doCountOfSubscribedMembers()
      this.selectedExtrasCount = x.extrasCount;
      this.selectedMembersCount = x.membersCount;
      this.searched_members = this.members
      this.loading = false;
    })
  }

  searchName(){
    if (this.nameSearchString.length > 0){
      this.firstnames = this.members.filter( a => a.firstName.toLowerCase().indexOf(this.nameSearchString.toLowerCase()) > -1) ;
      this.lastnames = this.members.filter( a => a.lastName.toLowerCase().indexOf(this.nameSearchString.toLowerCase()) > -1) ;
      this.searched_members = this.firstnames.concat(this.lastnames);
    }else{
      this.searched_members = this.members
    }
  }

  showRow(id: any){
    if (this.showOnlySelected && (this.isSubscribed(id) || this.checkHasPayedDeposit(id) || this.checkHasPayedFull(id) )) return true;
    else if (!this.showOnlySelected) return true;
  }

  isSubscribed(id: any){
    var item = this.selected_members.find( x => x.memberId == id)
    if (item){
      return item.subscribed;
    }
    else{
      return false
    }
  }

  checkHasPayedDeposit(id: any){
    var item = this.selected_members.find( x => x.memberId == id)  
    if (item){   
      return item.hasPayedDeposit;
    }
    else{
      return false;
    }
  }

  checkHasPayedFull(id: any){
    var item = this.selected_members.find( x => x.memberId == id)  
    if (item){   
      return item.hasPayedFull;
    }
    else{
      return false;
    }
  }

  checkHasRequestedSingleRoom(id:any){
      var item = this.selected_members.find( x => x.memberId == id)  
      if (item){   
        return item.singleRoom;
      }
      else{
        return false;
      }
  }

  checkHasPersonalTransport(id:any){
    var item = this.selected_members.find( x => x.memberId == id)  
    if (item){   
      return item.personalTransport;
    }
    else{
      return false;
    }
  }

  checkHasExtraQuestionResponse(id:any){
    var item = this.selected_members.find( x => x.memberId == id)  
    if (item){   
      return item.extraQuestionResponse;
    }
    else{
      return false;
    }
  }


  checkIsExemptFromPaying(id: any){
    var item = this.selected_members.find( x => x.memberId == id)  
    if (item){   
      return item.exemptFromPaying;
    }
    else{
      return false;
    }
  }

  hasExtras(id:any){
    var item = this.selected_members.find( x => x.memberId == id)
    if (item){
      if (item.extras > 0) return item.extras
      else return '';
    }
    else{
      return '';
    }
  }

  hasExtraNames(id:any){
    var item = this.selected_members.find( x => x.memberId == id)
    if (item){
      return item.extraNames;
    }
    else{
      return '';
    }
  }

  hasRemarks(id:any){
    var item = this.selected_members.find( x => x.memberId == id)
    if (item){
      return item.remarks;
    }
    else{
      return '';
    }
  }

  AmountOfNonStdBikes(id:any){
    var item = this.selected_members.find( x => x.memberId == id)
    if (item){
      return item.amountOfNonStdBikes;
    }
    else{
      return '';
    }
  }
  KindOfBikes(id:any){
    var item = this.selected_members.find( x => x.memberId == id)
    if (item){
      return item.kindOfBikes;
    }
    else{
      return '';
    }
  }

  checkboxSubscribeClicked(id: any) {   
    if (this.selected_members.find( x => x.memberId == id)){
      var item = this.selected_members.filter( x => x.memberId == id)[0];
      var index = this.selected_members.indexOf( item);
     
      if (index > -1) {
        this.selected_members.splice(index, 1);
        item.subscribed = !item.subscribed;       
        this.selected_members.push(item);
      }
    }else{
      this.selected_members.push({memberId:id, subscribed:true, extras:0, extraNames:'', remarks:'', amountOfNonStdBikes:0, kindOfBikes:'',singleRoom:false, personalTransport:false,extraQuestionResponse:false});
    }

    var x:any =  this.doCountOfSubscribedMembers()
    this.selectedExtrasCount = x.extrasCount;
    this.selectedMembersCount = x.membersCount;
    this.safeMemberScubscriptions();
  }

  checkboxPayedDepositClicked(id: any) {
    if (this.selected_members.find( x => x.memberId == id)){
      var item = this.selected_members.filter( x => x.memberId == id)[0];
      var index = this.selected_members.indexOf( item);

      if (index > -1) {
        this.selected_members.splice(index, 1);
        item.hasPayedDeposit = !item.hasPayedDeposit;       
        this.selected_members.push(item);
      }
    }else{
      this.selected_members.push({memberId:id,subscribed:true, hasPayedDeposit:true,extras:0, extraNames:'', remarks:'', amountOfNonStdBikes:0, kindOfBikes:'',singleRoom:false, personalTransport:false,extraQuestionResponse:false});
    }

    var x:any =  this.doCountOfSubscribedMembers()
    this.selectedExtrasCount = x.extrasCount;
    this.selectedMembersCount = x.membersCount;
    this.safeMemberScubscriptions();
  }

  checkboxPayedFullClicked(id: any) {
    if (this.selected_members.find( x => x.memberId == id)){
      var item = this.selected_members.filter( x => x.memberId == id)[0];
      var index = this.selected_members.indexOf( item);

      if (index > -1) {
        this.selected_members.splice(index, 1);
        item.hasPayedFull = !item.hasPayedFull;       
        this.selected_members.push(item);
      }
    }else{
      this.selected_members.push({memberId:id,subscribed:true ,hasPayedFull:true,extras:0, extraNames:'', remarks:'', amountOfNonStdBikes:0, kindOfBikes:'',singleRoom:false, personalTransport:false,extraQuestionResponse:false});
    }

    var x:any =  this.doCountOfSubscribedMembers()
    this.selectedExtrasCount = x.extrasCount;
    this.selectedMembersCount = x.membersCount;
    this.safeMemberScubscriptions();
  }

  checkboxExemptFromPayingClicked(id: any) {
    if (this.selected_members.find( x => x.memberId == id)){
      var item = this.selected_members.filter( x => x.memberId == id)[0];
      var index = this.selected_members.indexOf( item);

      if (index > -1) {
        this.selected_members.splice(index, 1);
        item.exemptFromPaying = !item.exemptFromPaying;       
        this.selected_members.push(item);
      }
    }else{
      this.selected_members.push({memberId:id,subscribed:true, hasPayedDeposit:false,exemptFromPaying:true,extras:0, extraNames:'', remarks:'', amountOfNonStdBikes:0, kindOfBikes:'',singleRoom:false, personalTransport:false,extraQuestionResponse:false});
    }

    var x:any =  this.doCountOfSubscribedMembers()
    this.selectedExtrasCount = x.extrasCount;
    this.selectedMembersCount = x.membersCount;
    this.safeMemberScubscriptions();
  }


  checkboxSingleRoomChanged(id: any){
    if (this.selected_members.find( x => x.memberId == id)){
      var item = this.selected_members.filter( x => x.memberId == id)[0];
      var index = this.selected_members.indexOf( item);

      if (index > -1) {
        this.selected_members.splice(index, 1);
        item.singleRoom = !item.singleRoom;       
        this.selected_members.push(item);
      }
    }else{
      this.selected_members.push({memberId:id,subscribed:true ,hasPayedFull:true,extras:0, extraNames:'', remarks:'',amountOfNonStdBikes:0, kindOfBikes:'',singleRoom:false, personalTransport:false,extraQuestionResponse:false});
    }

    var x:any =  this.doCountOfSubscribedMembers()
    this.selectedExtrasCount = x.extrasCount;
    this.selectedMembersCount = x.membersCount;
    this.safeMemberScubscriptions();
  }

  checkboxPersonalTransportChanged(id: any){
    if (this.selected_members.find( x => x.memberId == id)){
      var item = this.selected_members.filter( x => x.memberId == id)[0];
      var index = this.selected_members.indexOf( item);

      if (index > -1) {
        this.selected_members.splice(index, 1);
        item.personalTransport = !item.personalTransport;       
        this.selected_members.push(item);
      }
    }else{
      this.selected_members.push({memberId:id,subscribed:true ,hasPayedFull:true,extras:0, extraNames:'', remarks:'',amountOfNonStdBikes:0, kindOfBikes:'',singleRoom:false, personalTransport:false,extraQuestionResponse:false});
    }

    var x:any =  this.doCountOfSubscribedMembers()
    this.selectedExtrasCount = x.extrasCount;
    this.selectedMembersCount = x.membersCount;
    this.safeMemberScubscriptions();
  }

  checkboxExtraQuestionChanged(id: any){
    if (this.selected_members.find( x => x.memberId == id)){
      var item = this.selected_members.filter( x => x.memberId == id)[0];
      var index = this.selected_members.indexOf( item);

      if (index > -1) {
        this.selected_members.splice(index, 1);
        item.extraQuestionResponse = !item.extraQuestionResponse;       
        this.selected_members.push(item);
      }
    }else{
      this.selected_members.push({memberId:id,subscribed:true ,hasPayedFull:true,extras:0, extraNames:'', remarks:'',amountOfNonStdBikes:0, kindOfBikes:'',singleRoom:false, personalTransport:false, extraQuestionResponse:false});
    }

    var x:any =  this.doCountOfSubscribedMembers()
    this.selectedExtrasCount = x.extrasCount;
    this.selectedMembersCount = x.membersCount;
    this.safeMemberScubscriptions();
  }



  clearSearch(){
    this.nameSearchString = '';
    this.searchName();
  }

  doCountOfSubscribedMembers(){
    var membersCount  = 0;
    var extrasCount = 0;
    this.selected_members.forEach(element => {
      if (element.subscribed || element.hasPayedDeposit ){
        membersCount ++;
        extrasCount += element.extras;
      }
      if (!element.subscribed && ! element.hasPayedDeposit){
        var index = this.selected_members.indexOf(element);
        this.selected_members.splice(index,1);
      }
    });
    return {membersCount: membersCount, extrasCount:extrasCount};
  }

  safeMemberScubscriptions(){
    var subs: any = {}
    subs.subscriptionId = this.subscriptionId;
    subs.subscriptionMembers = [];
    this.selected_members.forEach(element => {
      var x:any = {
        memberId:element.memberId,  
        hasPayedDeposit:element.hasPayedDeposit,
        hasPayedFull: element.hasPayedFull,
        isSubscribed: element.subscribed,
        subscriptionId: subs.subscriptionId,
        singleRoom: element.singleRoom,
        extras: element.extras,
        extraNames: element.extraNames,
        exemptFromPaying: element.exemptFromPaying,
        personalTransport: element.personalTransport,
        extraQuestion: element.extraQuestionResponse
      }
      subs.subscriptionMembers.push(x);
    });

    console.log("SafeMemberSubscriptin: ",subs);
    

    this.subscriptionService.addMembersToSubscription(subs).subscribe(x => {
      // console.log(x);
    })
  }

  EditExtraCount(memberId: number){
    var m = this.selected_members.find( x=> x.memberId == memberId )
    Swal.fire({
      showCancelButton:true,
      cancelButtonText: "Annuleren",
      title: "Wijzigen extras",
      type: "question",
      text: 'Hoeveel Extras komen er mee?',
      input: 'number',
      inputValue:m.extras
    }).then( (result:any) => {
      if (result.value) {
        const amount = result.value;
        this.subscriptionService.updateExtrasCount(this.subscriptionId, memberId, amount).subscribe( (x:any) => {
          m.extras = +amount;
          var x:any =  this.doCountOfSubscribedMembers()
          this.selectedExtrasCount = x.extrasCount;
          this.selectedMembersCount = x.membersCount;
          
        })
      }
    })
  }

  EditAmountOfNonStdBikes(memberId:number){
    var m = this.selected_members.find( x=> x.memberId == memberId )
    Swal.fire({
      showCancelButton:true,
      cancelButtonText: "Annuleren",
      title: "Wijzigen aantal niet standard fietsen.",
      type: "question",
      text: 'Hoeveel niet standaard racefietsen neem je mee?',
      input: 'number',
      inputValue:m.amountOfNonStdBikes
    }).then( (result:any) => {
      if (result.value) {
        const amount = result.value;
        this.subscriptionService.updateAmountOfNonStdBikes(this.subscriptionId, memberId, amount).subscribe( (x:any) => {
          m.amountOfNonStdBikes = +amount;
          var x:any =  this.doCountOfSubscribedMembers()
          this.selectedExtrasCount = x.extrasCount;
          this.selectedMembersCount = x.membersCount;
        })
      }
    })
  }

  EditKindOfBikes(memberId: number){
    var m = this.selected_members.find( x=> x.memberId == memberId )
    Swal.fire({
      showCancelButton:false,
      cancelButtonText: "Annuleren",
      title: "Type fietsen? ",
      type: "question",
      text: 'Welk type fietsen neem je mee?',
      input: 'textarea',
      inputValue: m.kindOfBikes
    }).then( (result:any) => {
      /* Result can be empty */
      //if (result.value) {
        
        const models = result.value;
        this.subscriptionService.updateKindOfBikes(this.subscriptionId, memberId, models).subscribe( (x:any) => {
          m.kindOfBikes = models;
        })
      //}
    })
  }

  EditExtraNames(memberId: number){
    var m = this.selected_members.find( x=> x.memberId == memberId )
    Swal.fire({
      showCancelButton:false,
      cancelButtonText: "Annuleren",
      title: "Wijzigen extra namen",
      type: "question",
      text: 'Wat zijn de namen van de personen die je meebrengt?',
      input: 'textarea',
      inputValue: m.extraNames
    }).then( (result:any) => {
      /* Result can be empty */
      //if (result.value) {
        
        const names = result.value;
        this.subscriptionService.updateExtrasNames(this.subscriptionId, memberId, names).subscribe( (x:any) => {
          m.extraNames = names;
        })
      //}
    })
  }

  EditRemarks(memberId: number){
    var m = this.selected_members.find( x=> x.memberId == memberId )
    Swal.fire({
      showCancelButton:false,
      cancelButtonText: "Annuleren",
      title: "Wijzigen opmerkingen",
      type: "question",
      text: 'Wat zijn je opmerkingen?',
      input: 'textarea',
      inputValue: m.remarks
    }).then( (result:any) => {
      /* Result can be empty */
      //if (result.value) {
        
        const remark = result.value;
        this.subscriptionService.updateRemarks(this.subscriptionId, memberId, remark).subscribe( (x:any) => {
          m.remarks = remark;
        })
      //}
    })
  }

  SendEmailtoUser(memberId: number){
    Swal.fire({
      title: 'Ben je zeker?',
      html: "De betalings email zal worden verstuurd.",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Jep',
      cancelButtonText: 'Nope'
    }).then((result) => {
      if (result.value) {
        this.subscriptionService.sendPaymentEmailToMember(memberId,this.subscriptionId).subscribe( (res:any)=>{
          if (res.status == 200){
            Swal.fire({
              title: 'E-mail verstuurd',
              text: "Er is "+res.value.emailsSend+" mail verstuurd",
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'Ok',
            })
          }
        })
       
      }
    });
  }

  copyEmailAdressesToClipBoard(){
    this.subscriptionService.getSubscribedMembersEmail(this.subscriptionId).subscribe( (res:any)=>{
      // console.log(res);
      if (res.status == 200){
        // console.log(res.value);
        var addresses: string= "";

        res.value.forEach( (element:any) => {
          var email = element.email
          if (email.length > 0){
            addresses += email+";"
          }          
        });

        this.copyMessage(addresses);
        Swal.fire({
          // title: '',
          text: "Alle email adressen gekopieerd naar het clipboard",
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Ok',
        })
        
      }
    })
  }

  copyMessage(val: string){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/subscription-list-member-edit/subscription-list-member-edit.component.ts